module.exports = __webpack_public_path__ + "img/1515390850.92a24f5a.jpg";